import { render, staticRenderFns } from "./ApplicationUrbanismRegulation.vue?vue&type=template&id=93467bc8&"
import script from "./ApplicationUrbanismRegulation.vue?vue&type=script&lang=js&"
export * from "./ApplicationUrbanismRegulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports